<template>
  <img :src="shadowURL" ref="img" class="avatar-icon img-fluid rounded-circle">
</template>

<script>
export default {
  name: "avatar",

  props: {
    channelId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      loaded: false,
      maxWorker: 3,
      shadowURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAtJREFUeJxjYAACAAAFAAF6Xqs/AAAAAElFTkSuQmCC",
    }
  },

  watch: {
    channelId(newVal, oldVal) {
      if (newVal) {
        this.loaded = false;
        this.preload();
      }
    },
    loaded(newVal) {
      if (newVal) {
        window.removeEventListener("scroll", this.handleWindowChange);
        window.removeEventListener("resize", this.handleWindowChange);
      }
    }
  },

  mounted() {
    this.handleWindowChange();

    window.addEventListener("scroll", this.handleWindowChange);
    window.addEventListener("resize", this.handleWindowChange);
  },

  beforeDestroy() {
    window.removeEventListener("scroll", this.handleWindowChange);
    window.removeEventListener("resize", this.handleWindowChange);
  },

  methods: {
    preload() {
      if (!this.channelId || this.loaded) {
        return;
      }

      const workerCounter = window.avatarLoading || 0;
      if (workerCounter >= this.maxWorker) {
        setTimeout(this.preload, 500);
        return;
      }
      window.avatarLoading = workerCounter + 1;

      let shadowURL;
      shadowURL = this.loadCache(this.channelId);
      if (shadowURL) {
        this.shadowURL = shadowURL;
        window.avatarLoading--;
        return;
      }
      const url = `/upload/avatar/whatsapp/${this.channelId}`;
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.addEventListener("load", () => {
        const canvas = document.createElement('CANVAS');
        const ctx = canvas.getContext('2d');
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        shadowURL = canvas.toDataURL('png');
        if (shadowURL) {
          try {
            this.saveCache(this.channelId, shadowURL);
          } catch (e) {}
          this.shadowURL = shadowURL;
        }
        this.loaded = true;
        window.avatarLoading--;
      });
      img.addEventListener("error", () => {
        this.loaded = true;
        window.avatarLoading--;
      })
      img.src = url;
    },

    loadCache(channelID) {
      const store = window.storeAvatar || {};
      return store[channelID] || false;
    },

    saveCache(channelID, URL) {
      let store = window.storeAvatar || {};
      store[channelID] = URL;
      window.storeAvatar = store || {};
    },

    isInViewport(element) {
      const rect = element.getBoundingClientRect();
      return (
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },

    handleWindowChange() {
      if (this.$refs.img && this.isInViewport(this.$refs.img)) {
        this.preload();
      }
    }
  }
}
</script>

<style lang="scss">
.avatar-icon {
  width: 100%;
  height: auto;
  background-color: grey;
  background-image: url("data:image/svg+xml,%3Csvg t='1689919840864' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='12497' width='16' height='16'%3E%3Cpath d='M935.264 656.344c21.824 10.912 32.736 29.472 32.736 55.664l0 211.144 0 37.64c0 16.376-4.912 30.552-14.736 42.56-9.824 12-22.368 18-37.648 18L111.96 1021.352c-14.184 0-26.184-6-36.008-18-9.824-12.008-14.728-26.184-14.728-42.56l0-37.64L61.224 712.008c0-26.192 10.912-44.744 32.736-55.664l225.872-104.752 88.392-40.92c-41.464-25.096-73.112-61.112-94.936-108.032-20.728-41.464-31.096-85.656-31.096-132.576 0-14.184 1.088-27.832 3.272-40.92 2.176-13.096 4.904-25.64 8.176-37.648 15.28-55.656 42.832-101.48 82.656-137.488C416.136 18 462.232 0 514.608 0c53.472 0 100.392 18.552 140.76 55.656 40.384 37.104 67.656 84.024 81.84 140.76 5.464 27.28 8.192 51.832 8.192 73.656 0 43.648-8.736 85.664-26.192 126.032-21.832 49.104-53.472 86.208-94.928 111.304l93.296 44.192L935.264 656.344 935.264 656.344z' p-id='12498' fill='%232bbbad'%3E%3C/path%3E%3C/svg%3E");
  background-size: 80% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  opacity: 0.8;
}
</style>
